import AppPageTitle from '@/components/AppPageTitle';
import React, { useEffect, useState } from 'react';
import AppForm from '@/components/AppForm';
import PATH from '@/config/paths/PATH';
import { Col, Form, Input, Row, Switch } from 'antd';
import AppSelect from '@/components/AppSelect';
import { createTopicsAnswer } from '@/services/topic.service';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import useTopicOptionsQuery from '@/hooks/useTopicOptionsQuery';
import useFormSubmit from '@/hooks/useFormSubmit';
import usePaginatedQuery from '@/hooks/usePaginatedQuery';
import { getCharCore } from '@/services/config.service';
import { formatDataTopicAnswer } from '@/utils';
import { keywordInvalidValidator, keywordUnicodeValidator } from './validator';
import useMediaQuery, { mediaQueryPoints } from '@/hooks/useMediaQuery';

function TopicAnswerCreate() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { data: topicsData } = useTopicOptionsQuery();
  const [keywordUnicode, setKeywordUnicode] = useState('');

  const { data } = usePaginatedQuery(getCharCore, ['char-core']);
  const topicAnswerMutation = useMutation({
    mutationFn: createTopicsAnswer,
  });

  const handleOnSubmit = useFormSubmit(
    topicAnswerMutation,
    (values) => ({
      ...values,
      topic_id: String(values.topic_id),
      is_active: values.isActive ? '1' : '2',
    }),
    {
      onOK: () => {
        navigate(PATH.TOPIC_ANSWER.ROOT, {
          replace: true,
        });
      },
    }
  );

  useEffect(() => {
    if (keywordUnicode && form.getFieldValue('key_word')) {
      form.setFieldsValue({
        key_word_unicode: keywordUnicode.arrayKeyWord.join('/_/'),
      });
    }
  }, [keywordUnicode, form]);

  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoints.md}px)`);

  return (
    <div>
      <AppPageTitle title="Create Topic Answer" />
      <AppForm
        form={form}
        onSubmit={handleOnSubmit}
        targetPath={PATH.TOPIC_ANSWER.ROOT}
        buttonProps={{
          loading: topicAnswerMutation.isPending,
          disabled: topicAnswerMutation.isPending,
        }}
        disabled={topicAnswerMutation.isPending}
      >
        <Row gutter={16}>
          <Col span={isMobile ? 24 : 12}>
            <Form.Item
              label="Keyword"
              name="key_word"
              rules={[
                { required: true, message: 'Please enter keyword' },
                {
                  validator: (_, value) => {
                    return keywordInvalidValidator(value, data);
                  },
                },
              ]}
              tooltip={() => <span>စျဏဋဏ</span>}
            >
              <Input
                placeholder="Enter keyword"
                onChange={() => {
                  setKeywordUnicode(
                    formatDataTopicAnswer(data?.[0]?.config_value, form.getFieldValue('key_word'))
                  );
                }}
              />
            </Form.Item>

            <Form.Item
              label="Keyword Unicode"
              name="key_word_unicode"
              rules={[
                { required: true, message: 'Please enter keyword unicode' },
                {
                  validator: (_, value) => {
                    return keywordUnicodeValidator(value, keywordUnicode);
                  },
                },
              ]}
              tooltip={() => <span>စျ/_/ဏ/_/ဋ/_/ဏ</span>}
            >
              <Input placeholder="Enter keyword unicode" />
            </Form.Item>
            <Form.Item label="Topic" name="topic_id">
              <AppSelect
                items={topicsData?.dataRes?.map((item, index) => {
                  return {
                    value: item.id,
                    label: item.name_en.toString(),
                  };
                })}
                formItemClassName="mb-0"
                placeholder="Topic name"
              />
            </Form.Item>
          </Col>
          <Col span={isMobile ? 24 : 12}>
            <Form.Item
              label="Full Word Myanmar"
              name="full_word_my"
              rules={[{ required: true, message: 'Please enter full word Myanmar' }]}
            >
              <Input placeholder="Enter full word Myanmar" />
            </Form.Item>
            <Form.Item
              label="Full Word English"
              name="full_word_en"
              rules={[{ required: true, message: 'Please enter full word English' }]}
            >
              <Input placeholder="Enter full word English" />
            </Form.Item>
            <Form.Item name="is_active" valuePropName="checked" label="Active">
              <Switch title="Active" />
            </Form.Item>
          </Col>
        </Row>
      </AppForm>
    </div>
  );
}

export default TopicAnswerCreate;
